import { Controller as BaseController } from "@hotwired/stimulus";
import { decode } from "blurhash";

export class Controller extends BaseController {
  static values = { blurhash: String };
  static targets = ["image"]

  connect() {
    if (this.blurhashValue.length === 0) {
      return
    }

    this.drawBlurhash();
  }

  drawBlurhash() {
    const width = this.imageTarget.width;
    const height = this.imageTarget.height;

    if (width <= 0 || height <= 0) {
      return;
    }

    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;

    const pixels = decode(this.blurhashValue, width, height);
    const context = canvas.getContext("2d");
    const imageData = context.createImageData(width, height);
    imageData.data.set(pixels);
    context.putImageData(imageData, 0, 0);

    this.element.style.backgroundImage = `url(${canvas.toDataURL()})`;
  }
}
